import { CALL_API, Schemas } from '../../common/middleware/api';

export const WORKSHOPS_REQUEST = 'WORKSHOPS_REQUEST';
export const WORKSHOPS_SUCCESS = 'WORKSHOPS_SUCCESS';
export const WORKSHOPS_FAILURE = 'WORKSHOPS_FAILURE';

export const WORKSHOPS_SEARCH_REQUEST = 'WORKSHOPS_SEARCH_REQUEST';
export const WORKSHOPS_SEARCH_SUCCESS = 'WORKSHOPS_SEARCH_SUCCESS';
export const WORKSHOPS_SEARCH_FAILURE = 'WORKSHOPS_SEARCH_FAILURE';

export const WORKSHOPS_UNPAGED_REQUEST = 'WORKSHOPS_UNPAGED_REQUEST';
export const WORKSHOPS_UNPAGED_SUCCESS = 'WORKSHOPS_UNPAGED_SUCCESS';
export const WORKSHOPS_UNPAGED_FAILURE = 'WORKSHOPS_UNPAGED_FAILURE';

export const WORKSHOP_UPDATE_REQUEST = 'WORKSHOP_UPDATE_REQUEST';
export const WORKSHOP_UPDATE_SUCCESS = 'WORKSHOP_UPDATE_SUCCESS';
export const WORKSHOP_UPDATE_FAILURE = 'WORKSHOP_UPDATE_FAILURE';

export const WORKSHOP_CREATE_REQUEST = 'WORKSHOP_CREATE_REQUEST';
export const WORKSHOP_CREATE_SUCCESS = 'WORKSHOP_CREATE_SUCCESS';
export const WORKSHOP_CREATE_FAILURE = 'WORKSHOP_CREATE_FAILURE';

export const WORKSHOP_FETCH_REQUEST = 'WORKSHOP_FETCH_REQUEST';
export const WORKSHOP_FETCH_SUCCESS = 'WORKSHOP_FETCH_SUCCESS';
export const WORKSHOP_FETCH_FAILURE = 'WORKSHOP_FETCH_FAILURE';

export const WORKSHOP_SESSION_DELETE_REQUEST = 'WORKSHOP_SESSION_DELETE_REQUEST';
export const WORKSHOP_SESSION_DELETE_SUCCESS = 'WORKSHOP_SESSION_DELETE_SUCCESS';
export const WORKSHOP_SESSION_DELETE_FAILURE = 'WORKSHOP_SESSION_DELETE_FAILURE';

export const WORKSHOP_SESSION_UPDATE_REQUEST = 'WORKSHOP_SESSION_UPDATE_REQUEST';
export const WORKSHOP_SESSION_UPDATE_SUCCESS = 'WORKSHOP_SESSION_UPDATE_SUCCESS';
export const WORKSHOP_SESSION_UPDATE_FAILURE = 'WORKSHOP_SESSION_UPDATE_FAILURE';

export const WORKSHOP_SESSION_CREATE_REQUEST = 'WORKSHOP_SESSION_CREATE_REQUEST';
export const WORKSHOP_SESSION_CREATE_SUCCESS = 'WORKSHOP_SESSION_CREATE_SUCCESS';
export const WORKSHOP_SESSION_CREATE_FAILURE = 'WORKSHOP_SESSION_CREATE_FAILURE';

export const WORKSHOP_SESSION_CREATE_DATE_REQUEST = 'WORKSHOP_SESSION_CREATE_DATE_REQUEST';
export const WORKSHOP_SESSION_CREATE_DATE_SUCCESS = 'WORKSHOP_SESSION_CREATE_DATE_SUCCESS';
export const WORKSHOP_SESSION_CREATE_DATE_FAILURE = 'WORKSHOP_SESSION_CREATE_DATE_FAILURE';

export const WORKSHOP_WEEK_CREATE_REQUEST = 'WORKSHOP_WEEK_CREATE_REQUEST';
export const WORKSHOP_WEEK_CREATE_SUCCESS = 'WORKSHOP_WEEK_CREATE_SUCCESS';
export const WORKSHOP_WEEK_CREATE_FAILURE = 'WORKSHOP_WEEK_CREATE_FAILURE';

export const WORKSHOP_WEEK_UPDATE_REQUEST = 'WORKSHOP_WEEK_UPDATE_REQUEST';
export const WORKSHOP_WEEK_UPDATE_SUCCESS = 'WORKSHOP_WEEK_UPDATE_SUCCESS';
export const WORKSHOP_WEEK_UPDATE_FAILURE = 'WORKSHOP_WEEK_UPDATE_FAILURE';

export const WORKSHOP_WEEK_DELETE_REQUEST = 'WORKSHOP_WEEK_DELETE_REQUEST';
export const WORKSHOP_WEEK_DELETE_SUCCESS = 'WORKSHOP_WEEK_DELETE_SUCCESS';
export const WORKSHOP_WEEK_DELETE_FAILURE = 'WORKSHOP_WEEK_DELETE_FAILURE';

export const WORKSHOP_SESSIONS_REQUEST = 'WORKSHOP_SESSIONS_REQUEST';
export const WORKSHOP_SESSIONS_SUCCESS = 'WORKSHOP_SESSIONS_SUCCESS';
export const WORKSHOP_SESSIONS_FAILURE = 'WORKSHOP_SESSIONS_FAILURE';

export const WORKSHOP_CLONE_DATE_REQUEST = 'WORKSHOP_CLONE_DATE_REQUEST';
export const WORKSHOP_CLONE_DATE_SUCCESS = 'WORKSHOP_CLONE_DATE_SUCCESS';
export const WORKSHOP_CLONE_DATE_FAILURE = 'WORKSHOP_CLONE_DATE_FAILURE';

export const WORKSHOP_CLONE_WEEK_REQUEST = 'WORKSHOP_CLONE_WEEK_REQUEST';
export const WORKSHOP_CLONE_WEEK_SUCCESS = 'WORKSHOP_CLONE_WEEK_SUCCESS';
export const WORKSHOP_CLONE_WEEK_FAILURE = 'WORKSHOP_CLONE_WEEK_FAILURE';

export const loadWorkshops = (options) => ({
	[CALL_API]: {
		types: [
			WORKSHOPS_REQUEST,
			WORKSHOPS_SUCCESS,
			WORKSHOPS_FAILURE
		],
		endpoint: 'api/workshops',
		request: options,
		schema: Schemas.WORKSHOP_ARRAY
	}
});

export const loadWorkshopsBySearchTerm = ({ name, ...options }) => ({
	[CALL_API]: {
		types: [
			WORKSHOPS_SEARCH_REQUEST,
			WORKSHOPS_SEARCH_SUCCESS,
			WORKSHOPS_SEARCH_FAILURE
		],
		endpoint: 'api/workshops',
		request: { name, ...options },
		schema: Schemas.WORKSHOP_ARRAY
	},
	searchTerm: name || ''
});

export const loadUnpagedWorkshops = (options, onSuccessEvent, onErrorEvent) => ({
	[CALL_API]: {
		types: [WORKSHOPS_UNPAGED_REQUEST, WORKSHOPS_UNPAGED_SUCCESS, WORKSHOPS_UNPAGED_FAILURE],
		endpoint: 'api/workshops/unpaged',
		request: options,
		schema: Schemas.WORKSHOP_ARRAY,
		onSuccessEvent,
		onErrorEvent
	}
});

export const fetchWorkshop = (id) => ({
	[CALL_API]: {
		types: [
			WORKSHOP_FETCH_REQUEST,
			WORKSHOP_FETCH_SUCCESS,
			WORKSHOP_FETCH_FAILURE
		],
		endpoint: `api/workshops/${id}`,
		schema: Schemas.WORKSHOP
	}
});

export const createWorkshop = (options, history) => ({
	[CALL_API]: {
		types: [
			WORKSHOP_CREATE_REQUEST,
			WORKSHOP_CREATE_SUCCESS,
			WORKSHOP_CREATE_FAILURE
		],
		endpoint: 'api/workshops',
		method: 'POST',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'newWorkshop',
		transition: {
			history,
			successPath: (response) => {
				return `/workshops/${response.result}`;
			}
		}
	}
});

export const updateWorkshop = (id, options, history) => ({
	[CALL_API]: {
		types: [
			WORKSHOP_UPDATE_REQUEST,
			WORKSHOP_UPDATE_SUCCESS,
			WORKSHOP_UPDATE_FAILURE
		],
		endpoint: `api/workshops/${id}`,
		method: 'PUT',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'workshop',
		transition: {
			history,
			successPath: () => '/workshops'
		}
	}
});
export const deleteSession = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_SESSION_DELETE_REQUEST, WORKSHOP_SESSION_DELETE_SUCCESS, WORKSHOP_SESSION_DELETE_FAILURE],
		endpoint: `api/workshops/sessions/${id}`,
		method: 'DELETE',
		schema: Schemas.WORKSHOP,
		form: 'session',
		onSuccessEvent
	}
});

export const createSession = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_SESSION_CREATE_REQUEST, WORKSHOP_SESSION_CREATE_SUCCESS, WORKSHOP_SESSION_CREATE_FAILURE],
		endpoint: `api/workshops/sessions`,
		method: 'POST',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'session',
		onSuccessEvent
	}
})

export const createSessionDate = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_SESSION_CREATE_DATE_REQUEST, WORKSHOP_SESSION_CREATE_DATE_SUCCESS, WORKSHOP_SESSION_CREATE_DATE_FAILURE],
		endpoint: `api/workshops/sessions/newDate`,
		method: 'POST',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'newSessionDate',
		onSuccessEvent
	}
})
export const saveSession = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_SESSION_UPDATE_REQUEST, WORKSHOP_SESSION_UPDATE_SUCCESS, WORKSHOP_SESSION_UPDATE_FAILURE],
		endpoint: `api/workshops/sessions/${id}`,
		method: 'PUT',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'session',
		onSuccessEvent
	}
})

export const createWeek = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_WEEK_CREATE_REQUEST, WORKSHOP_WEEK_CREATE_SUCCESS, WORKSHOP_WEEK_CREATE_FAILURE],
		endpoint: `api/workshopWeeks`,
		method: 'POST',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'week',
		onSuccessEvent
	}
})
export const saveWeek = (id, options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_WEEK_UPDATE_REQUEST, WORKSHOP_WEEK_UPDATE_SUCCESS, WORKSHOP_WEEK_UPDATE_FAILURE],
		endpoint: `api/workshopWeeks/${id}`,
		method: 'PUT',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'week',
		onSuccessEvent
	}
})

export const deleteWeek = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_WEEK_DELETE_REQUEST, WORKSHOP_WEEK_DELETE_SUCCESS, WORKSHOP_WEEK_DELETE_FAILURE],
		endpoint: `api/workshopWeeks/${id}`,
		method: 'DELETE',
		schema: Schemas.WORKSHOP,
		form: 'workshop',
		onSuccessEvent
	}
})


export const loadWorkshopSessions = (workshopId, onSuccessEvent, onErrorEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_SESSIONS_REQUEST, WORKSHOP_SESSIONS_SUCCESS, WORKSHOP_SESSIONS_FAILURE],
		endpoint: `api/workshops/${workshopId}/sessions`,
		schema: Schemas.WORKSHOP_SESSIONS_ARRAY,
		onSuccessEvent,
		onErrorEvent
	},
	workshopId: workshopId
});

export const cloneDate = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_CLONE_DATE_REQUEST, WORKSHOP_CLONE_DATE_SUCCESS, WORKSHOP_CLONE_DATE_FAILURE],
		endpoint: `api/workshops/sessions/cloneDate`,
		method: 'POST',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'cloneDate',
		onSuccessEvent
	}
})

export const cloneWeek = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [WORKSHOP_CLONE_WEEK_REQUEST, WORKSHOP_CLONE_WEEK_SUCCESS, WORKSHOP_CLONE_WEEK_FAILURE],
		endpoint: `api/workshops/sessions/cloneWeek`,
		method: 'POST',
		request: options,
		schema: Schemas.WORKSHOP,
		form: 'cloneWeek',
		onSuccessEvent
	}
})
export const WorkshopSessionTimes = {
	MorningStartTime: 9,
	MorningEndTime: 12,
	AfternoonStartTime: 13,
	AfternoonEndTime: 16
}